import type { FileProtocols, VariableFieldADTValue } from '@lighthouse/core'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import type { FetchPexelsParams, PexelsResponse } from '../../../../types/file'
import { Pexels } from '../../../Pexels'

interface CustomPexelsProps {
    onChange: (value: VariableFieldADTValue) => void
    onFetchPexelsList?: (params: FetchPexelsParams) => Promise<PexelsResponse>
}

const SCxContainer = styled.div`
    width: 480px;
    height: 400px;
    padding: 12px;
`

const CustomPexels: React.FunctionComponent<CustomPexelsProps> = ({ onChange, onFetchPexelsList }) => {
    const handleChange = useCallback(
        (file: FileProtocols) => {
            onChange({ type: 'file', value: [file.url] })
        },
        [onChange]
    )

    if (!onFetchPexelsList) {
        return null
    }

    return (
        <SCxContainer>
            <Pexels onClick={handleChange} onFetchPexelsList={onFetchPexelsList} />
        </SCxContainer>
    )
}

export default CustomPexels
